export default {
  create: 'crumb/CREATE',
  update: 'crumb/UPDATE',
  remove: 'crumb/REMOVE',
};
